import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";
import {
  AuthProvider,
  OSSSnackbarProvider,
  DVTheme,
  AnalyticsProvider,
  OSSPerformanceMetrics
} from "@oss/components";

import Root from "./Root";

// DO NOT CHANGE THE "root" VALUE WITHOUT UPDATING THE SAME VALUE IN uptimerobot.com
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <AuthProvider>
    <AnalyticsProvider trackers={["ga"]}>
      <MuiThemeProvider theme={DVTheme}>
        <OSSSnackbarProvider>
          <OSSPerformanceMetrics />
          <Root />
        </OSSSnackbarProvider>
      </MuiThemeProvider>
    </AnalyticsProvider>
  </AuthProvider>
);
